import React, { useEffect, useRef, useState } from 'react';
import { CATEGORY_OPTIONS } from './constants';

interface Props {
  selectedCategoryId: string;
  suggestedCategoryId: string;
  onChange: (id: string) => void;
}

export default function CategoryDropdown({ selectedCategoryId, suggestedCategoryId, onChange }: Props): React.ReactElement {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const selected = CATEGORY_OPTIONS.find((c) => c.id === selectedCategoryId) ?? CATEGORY_OPTIONS[0];

  return (
    <div ref={wrapRef} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`inline-flex items-center h-9 w-full border bg-white rounded-md cursor-pointer transition-colors ${
          open ? 'border-teal-dark ring-2 ring-teal-dark/15' : 'border-line hover:border-ink4'
        }`}
      >
        <span className="flex-1 text-left text-small font-semibold text-ink px-3 truncate">
          {selected.name}
        </span>
        <span className="w-px h-5 bg-line flex-shrink-0" />
        <span className="px-2.5 text-helper text-[11px]">▾</span>
      </button>
      {open && (
        <div className="absolute left-0 right-0 mt-1 z-10 bg-white border border-line rounded-md shadow-card py-1 max-h-72 overflow-y-auto">
          {CATEGORY_OPTIONS.map((opt) => {
            const isSelected = opt.id === selectedCategoryId;
            const isVelaPick = opt.id === suggestedCategoryId;
            return (
              <button
                key={opt.id}
                type="button"
                onClick={() => {
                  onChange(opt.id);
                  setOpen(false);
                }}
                className="w-full flex items-center gap-2 px-3 py-2 text-small text-ink text-left bg-white hover:bg-[#EEF4FB] cursor-pointer border-none"
              >
                {isSelected ? (
                  <span className="text-teal-dark font-extrabold w-3 inline-flex justify-center">✓</span>
                ) : (
                  <span className="w-3" />
                )}
                <span className="flex-1 truncate">{opt.name}</span>
                {isVelaPick && (
                  <span className="ml-auto text-[9.5px] font-bold text-vela-deep bg-vela-fade px-1.5 py-0.5 rounded tracking-wider uppercase">
                    Vela
                  </span>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}